import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CycleIcon from "@mui/icons-material/Autorenew";
import PolicyIcon from "@mui/icons-material/Policy";
import TemplateIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminIcon from "@mui/icons-material/Security";
import LabelIcon from "@mui/icons-material/Label";
import EntityIcon from "@mui/icons-material/AccountTree";
import PermissionIcon from "@mui/icons-material/Lock";
import ArchiveIcon from '@mui/icons-material/Archive';
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Avatar, Divider } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import resources from "../../../images/logo-publicis-groupe.png";
import classNames from "classnames";
import styles from "./Navbar.module.css";
import { useDispatch, useSelector } from "react-redux";
import "../../../App.css";
import { DcoiActions, GetDefaulFormLabelByUserName, GetUserDetailByUPN } from "../../../Reducers/dcoi";
import { useEffect } from "react";
import { ArrowForwardIos } from "@mui/icons-material";




function NavbarComponent() {
  const dispatch = useDispatch();
  const { menu,subMenu,languageData,userDetails} = useSelector(
    (state) => state.dcoi
  );

  const [showSubMenu, setShowSubMenu] = React.useState(false);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [activeItem, setActiveItem] = React.useState()
  const[activeSubItem,setActiveSubItem]=useState();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(GetDefaulFormLabelByUserName());
    dispatch(GetUserDetailByUPN());
  }, [])


useEffect(() => {
  const currentPath = location.pathname.toLowerCase();
  const isVendor = currentPath.startsWith("/app-vcoi");
  const activePages = isVendor ? Vendorpages : pages;
  const activeSubMenuList = isVendor ? VcoiSubMenuItems : SubMenuItems;
  const matchingSubMenu = activeSubMenuList.find(sub =>
    currentPath.startsWith(sub.path.toLowerCase())
  );
  if (matchingSubMenu) {
    const adminName = isVendor ? "Vcoi-Admin" : "Admin";
    setActiveItem(adminName);
    setActiveSubItem(matchingSubMenu.name);
    dispatch(
      DcoiActions.activeDisplay({
        menu: adminName,
        subMenu: matchingSubMenu.displayName
      })
    );
    return;
  }

  if (currentPath.includes("sitecontent") || currentPath.includes("vcoisitecontent")) {
    return;
  }

  const matchingPage = activePages.find(page =>
    currentPath.startsWith(page.path.toLowerCase())
  );

  if (matchingPage) {
    setActiveItem(matchingPage.name);
    dispatch(
      DcoiActions.activeDisplay({
        menu: matchingPage.name,
        subMenu: matchingPage.displayName
      })
    );
  }
}, [location.pathname]);

  const pages = [
    { path: "/app-dcoi/respondents", name: "Respondent", displayName: menu },
    { path: "/app-dcoi", name: "My Submission", displayName: languageData?.Key_MasterPage_3 },
    { path: "/app-dcoi/sitecontent/", name: "Admin", displayName: menu },
  ].filter((page) => {
    // Hide "Respondent" and "Site Content" if both flags are true
    if (userDetails.IsEntityAdmin || userDetails.IsSiteAdmin) {
      return true;
    } else {
      return page.name !== "Respondent" && page.name !== "Admin";
    }
  });


  const Vendorpages = [   { path: "/app-vcoi/respondentsVcoi", name: "Respondent", displayName: menu },
    { path: "/app-vcoi", name: "My Submission", displayName: languageData?.Key_MasterPage_3 },
    // { path: "/app-vcoi/vcoisitecontent/", name: "Vcoi-Admin", displayName: menu },
  ].filter((page) => {
    // Hide "Respondent" and "Site Content" if both flags are true
    if (userDetails.IsEntityAdmin || userDetails.IsSiteAdmin) {
      return true;
    } else {
      return page.name !== "Respondent" && page.name !== "Admin";
    }
  });

  const SubMenuItems = [
    {
      path: "/app-dcoi/sitecontent/SendInvitationReminder",
      name: "Send Invitation/Reminder",
      displayName: "Send Invitation/Reminder",
      icon: <MailOutlineIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManageSubmissionCycle",
      name: "Manage Cycle",
      displayName: "Manage Cycle",
      icon: <CycleIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManagePolicyContentHome",
      name: "Manage Policy Content",
      displayName: "Manage Policy Content",
      icon: <PolicyIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManageEmailTemplateHome",
      name: "Manage Email Template",
      displayName: "Manage Email Template",
      icon: <TemplateIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManagePolicyAndEmailSetting",
      name: "Manage Policy and Email Settings",
      displayName: "Manage Policy and Email Settings",
      icon: <SettingsIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManageAdminPermission",
      name: "Manage Admin Permission",
      displayName: "Manage Admin Permission",
      icon: <AdminIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManageFormLabels",
      name: "Manage Form Labels",
      displayName: "Manage Form Labels",
      icon: <LabelIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ManageEntity",
      name: "Manage Entity",
      displayName: "Manage Entity",
      icon: <EntityIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/SitePermission",
      name: "Site Permission",
      displayName: "Site Permission",
      icon: <PermissionIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-dcoi/sitecontent/ViewArchives",
      name: "View Archive",
      displayName: "View Archive",
      icon: <ArchiveIcon sx={{ color: "white" }} />,
    }
  ].filter((subMenu) => {
    if (userDetails.IsSiteAdmin) {
      return true;
    } else if (userDetails.IsEntityAdmin) {
      return subMenu.name !== "Manage Admin Permission" && subMenu.name !== "Manage Form Labels" && subMenu.name !== "Manage Entity" && subMenu.name !== "Site Permission";
    }
    else {
      return true
    }
  });

    const VcoiSubMenuItems = [
    // {
    //   path: "/app-vcoi/vcoisitecontent/VcoiSendInvitationReminder",
    //   name: "Send Invitation/Reminder",
    //   displayName: "Send Invitation/Reminder",
    //   icon: <MailOutlineIcon sx={{ color: "white" }} />,
    // },
    {
      path: "/app-vcoi/Vcoisitecontent/VcoiManagePolicyContentHome",
      name: "Manage Policy Content",
      displayName: "Manage Policy Content",
      icon: <PolicyIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-vcoi/vcoisitecontent/VcoiManageEmailTemplateHome",
      name: "Manage Email Template",
      displayName: "Manage Email Template",
      icon: <TemplateIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-vcoi/vcoisitecontent/VcoiManagePolicyAndEmailSetting",
      name: "Manage Policy and Email Settings",
      displayName: "Manage Policy and Email Settings",
      icon: <SettingsIcon sx={{ color: "white" }} />,
    },
    // {
    //   path: "/app-vcoi/Vcoisitecontent/VcoiManageFormLabels",
    //   name: "Manage Form Labels",
    //   displayName: "Manage Form Labels",
    //   icon: <LabelIcon sx={{ color: "white" }} />,
    // },
    {
      path: "/app-vcoi/vcoisitecontent/VcoiManageEntity",
      name: "Manage Entity",
      displayName: "Manage Entity",
      icon: <EntityIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-vcoi/Vcoisitecontent/VcoiManageAdminPermission",
      name: "Manage Admin Permission",
      displayName: "Manage Admin Permission",
      icon: <AdminIcon sx={{ color: "white" }} />,
    },
    {
      path: "/app-vcoi/Vcoisitecontent/VcoiSitePermission",
      name: "Site Permission",
      displayName: "Site Permission",
      icon: <PermissionIcon sx={{ color: "white" }} />,
    }
  ].filter((subMenu) => {
    if (userDetails.IsSiteAdmin) {
      return true;
    } else if (userDetails.IsEntityAdmin) {
      return subMenu.name !== "Manage Admin Permission" && subMenu.name !== "Manage Form Labels" && subMenu.name !== "Manage Entity" && subMenu.name !== "Site Permission";
    }
    else {
      return true
    }
  });




  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    try {
      const account = instance.getActiveAccount();
      if (!account) {
        console.warn("No active account found. Redirecting to home...");
        window.location.href = "/";
        return;
      }
      await instance.removeAccount(account);
      instance.clearCache(); // No need to await
      await instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
        logoutHint: account.username, // Forces Microsoft to require re-login
      });
    } catch (error) {
      window.location.href =
        "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=" +
        encodeURIComponent(window.location.origin);
    } finally {
      // Ensure full session cleanup
      localStorage.clear();
      sessionStorage.clear();
    }
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const getShortName = (Name) => {
    if (Name === null || !Name) {
      return "NA";
    }
    const matches = Name.match(/\b(\w)/g);
    return matches.join("").substring(0, 2);
  };

const handlePageClick = (page) => {
  if (location.pathname === page.path) {
    handleClose();
    return;
  }
  dispatch(DcoiActions.activeDisplay({ menu: page.name, subMenu: page.displayName }));
  setActiveItem(page.name);
  setShowSubMenu(false);
  setActiveSubItem("");
  handleCloseNavMenu();
  navigate(page.path);
};


  

const handleSubMenuItemClick = (subMenuItem) => {
  setActiveSubItem(subMenuItem.name);
  dispatch(DcoiActions.activeDisplay({ menu: activeItem, subMenu: subMenuItem.displayName })); // save in Redux
  navigate(subMenuItem.path);
  handleClose();
};


  return (
    <>
      <AppBar position="fixed" sx={{ top: 0, width: "100%", backgroundColor: " #212129" }}>
        <div className="container">
          <Container maxWidth="xl" sx={{ marginBottom: "0px !important" }}>
            <Toolbar disableGutters sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                  display: { xs: "none", md: "flex" },
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                <img className={classNames(styles.HeaderLogo)} src={resources} alt="Logo" />
                {/* {location.pathname.startsWith("/app-vcoi") ?  <img style={{height:"50px",width:"50px"}} className={classNames(styles.HeaderLogo)} src={Sapient} alt="Logo" /> : <img className={classNames(styles.HeaderLogo)} src={resources} alt="Logo" />} */}
                <div className={classNames(styles.HeaderTitle)}>
                <Typography sx={{ fontSize: "10px" }}>
                  {location.pathname.startsWith("/app-vcoi") && (
                    <>
                      VENDOR CONFLICT OF INTEREST AND SERVICE TO OUTSIDE ORGANIZATIONS
                      <br />
                      {languageData?.Key_MasterPage_2}
                    </>
                  )}

                  {location.pathname.startsWith("/app-dcoi") && (
                    <>
                      {languageData?.Key_MasterPage_1}
                      <br />
                      {languageData?.Key_MasterPage_2}
                    </>
                  )}
                </Typography>
                </div>
              </Typography>
              <Typography
                variant="h5"
                noWrap
                component="a"
                href=""
                sx={{
                  display: { xs: "flex", md: "none" },
                  flexGrow: 1,
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                <img className={classNames(styles.HeaderLogo)} src={resources} alt="Logo" />
                {/* {location.pathname.startsWith("/app-vcoi") ?  <img style={{height:"50px",width:"50px"}} className={classNames(styles.HeaderLogo)} src={Sapient} alt="Logo" /> : <img className={classNames(styles.HeaderLogo)} src={resources} alt="Logo" />} */}
              </Typography>
              <Box sx={{ flexGrow: 0, backgroundColor: " #212129", color: "white" }}>
                <div>
                  <Tooltip title="User Menu">
                    <IconButton onClick={handleClick}>
                      <Avatar sx={{ backgroundColor: "#c8e1f9", color: "#1077D6" }}>{getShortName(window.name)}</Avatar>
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{ display: "flex", justifyContent: "center", mt: "55px", "& .MuiMenu-paper": { backgroundColor: " #212129", color: "white", minWidth: "300px", overflow: "overlay" } }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "10px", backgroundColor: " #212129", color: "white" }}>
                      <Typography sx={{ padding: "5px",fontWeight:"bold"}}>Publicis Groupe</Typography>
                      <Typography
                        onClick={handleSignOut}
                        sx={{
                          padding: "5px",fontWeight:"bold", cursor: "pointer", "&:hover": {
                            textDecoration: "underline"
                          }
                        }}
                      >
                        Logout
                      </Typography>
                    </Box>
                    <Divider color="white"/>
                    <Box sx={{ padding: "10px" }}>
                      <Box sx={{ display: "flex", justifyContent: "center", height: "60px" }}>
                        <Avatar sx={{ height: "60px", width: "60px", fontWeight: "bolder", fontSize: "x-large", backgroundColor: "#c8e1f9", color: "#1077D6" }}>{getShortName(window.name)}</Avatar>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: "bolder", fontSize: "24px" }}>
                          {userDetails?.Name}
                        </Typography>
                        </Box>
                    </Box>
                    <Divider color="white"/>
                    <Box sx={{display:"block",margin:"10px"}}>
                      <Typography sx={{padding:"10px",fontSize:"14px"}}>
                        {userDetails?.JobTitle}
                      </Typography>
                      <Typography sx={{padding:"10px",fontSize:"14px"}}>
                        {userDetails?.UserName}
                      </Typography>
                      </Box>
                    {location.pathname.startsWith("/app-dcoi") && (userDetails.IsEntityAdmin || userDetails.IsSiteAdmin) ? pages.map((page,index) => (
                      <React.Fragment key={index}>
                        <MenuItem
                          onClick={() => {
                            if (page.name === "Admin") {
                              setActiveItem(page.name);
                              setShowSubMenu(!showSubMenu);
                            } else {
                              setActiveItem(page.name);
                              handlePageClick(page);
                              handleClose();
                            }
                          }}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            backgroundColor: " #212129",
                            fontSize: "14px",
                            color: "white",
                            textDecoration: activeItem === page.name ? "underLine" : "none",
                            "&:hover": { backgroundColor: "white", opacity: 1, color: " #212129" }
                          }}
                        >
                          {page.name}
                          {page.name === "Admin" && (
                            <ArrowForwardIos
                              sx={{
                                transition: "transform 0.3s",
                                transform: showSubMenu ? "rotate(180deg)" : "rotate(0deg)",
                              }}
                            />
                          )}
                        </MenuItem>
                        {page.name === "Admin" && showSubMenu && (
                          SubMenuItems.map((subMenuItem) => (
                          <React.Fragment key={subMenuItem.path}>
                            {subMenuItem.name === "View Archives" && (
                              <div
                                className={classNames(styles.SubmenuStyle)}
                              />
                            )}
                            <MenuItem
                              key={subMenuItem.name}
                              sx={{
                                pl: 4,
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                color: activeSubItem === subMenuItem.name ? " #212129" : "white",
                                backgroundColor: activeSubItem === subMenuItem.name ? "white" : " #212129",
                                "&:hover": {
                                  backgroundColor: "white",
                                  opacity: 1,
                                  color: " #212129",  // Change text color on hover
                                },
                                "& svg": {
                                  transition: "color 0.3s", // Smooth color transition
                                  color: activeSubItem === subMenuItem.name ? " #212129" : "white", // Icon color
                                },
                                "&:hover svg": {
                                  color: " #212129", // Change icon color on hover
                                },
                              }}
                              onClick={() => {
                                handleSubMenuItemClick(subMenuItem);
                              }}
                            >
                              {subMenuItem.icon}
                              {subMenuItem.name}
                            </MenuItem>

                            {subMenuItem.name === "Send Invitation/Reminder" && (
                    <Divider color="white"/>
                            )}

                            {subMenuItem.name === "Manage Policy and Email Setting" && (
                    <Divider color="white"/>
                            )}
                          </React.Fragment>))
                        )}
                      </React.Fragment>
                    )):""}
                    {userDetails.IsVendor && location.pathname.startsWith("/app-vcoi") ? Vendorpages.map((page,index) => (
                      <React.Fragment key={index}>
                        <MenuItem
                          onClick={() => {
                            if (page.name === "Vcoi-Admin") {
                              setActiveItem(page.name);
                              setShowSubMenu(!showSubMenu);
                            } else {
                              setActiveItem(page.name);
                              handlePageClick(page);
                              handleClose();
                            }
                          }}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            backgroundColor: " #212129",
                            fontSize: "14px",
                            color: "white",
                            textDecoration: activeItem === page.name ? "underLine" : "none",
                            "&:hover": { backgroundColor: "white", opacity: 1, color: " #212129" }
                          }}
                        >
                          {page.name}
                          {page.name == "Vcoi-Admin" && (
                            <ArrowForwardIos
                              sx={{
                                transition: "transform 0.3s",
                                transform: showSubMenu ? "rotate(180deg)" : "rotate(0deg)",
                              }}
                            />
                          )}
                        </MenuItem>
                        {page.name === "Vcoi-Admin" && showSubMenu && (
                          VcoiSubMenuItems.map((subMenuItem) => (
                          <React.Fragment key={subMenuItem.path}>
                            {subMenuItem.name === "View Archives" && (
                              <div
                                className={classNames(styles.SubmenuStyle)}
                              />
                            )}
                            <MenuItem
                              key={subMenuItem.name}
                              sx={{
                                pl: 4,
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                color: activeSubItem === subMenuItem.name ? " #212129" : "white",
                                backgroundColor: activeSubItem === subMenuItem.name ? "white" : " #212129",
                                "&:hover": {
                                  backgroundColor: "white",
                                  opacity: 1,
                                  color: " #212129",  // Change text color on hover
                                },
                                "& svg": {
                                  transition: "color 0.3s", // Smooth color transition
                                  color: activeSubItem === subMenuItem.name ? " #212129" : "white", // Icon color
                                },
                                "&:hover svg": {
                                  color: " #212129", // Change icon color on hover
                                },
                              }}
                              onClick={() => {
                                handleSubMenuItemClick(subMenuItem);
                              }}
                            >
                              {subMenuItem.icon}
                              {subMenuItem.name}
                            </MenuItem>

                            {subMenuItem.name === "Send Invitation/Reminder" && (
                    <Divider color="white"/>
                            )}

                            {subMenuItem.name === "Manage Policy and Email Setting" && (
                    <Divider color="white"/>
                            )}
                          </React.Fragment>))
                        )}
                      </React.Fragment>
                    )):""}
                  </Menu>
                </div>
              </Box>
            </Toolbar>
          </Container>
        </div>
      </AppBar>
      {/* {
(location.pathname === "/app-vcoi") || (location.pathname === "/app-dcoi") ? 
      <nav className="navbar">
        <div className="title">{subMenu}</div>
      </nav> : <nav className="navbar">
      </nav>
      } */}

            {location.pathname.startsWith("/app-vcoi") || location.pathname.startsWith("/app-dcoi") ? 
      <nav className="navbar">
        <div className="title">{subMenu}</div>
      </nav> : <nav className="navbar">
      </nav>
      }
      
    </>
  );
}

export default NavbarComponent;